import './publicPath';
import '@/util/i18n';
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import plugins from '@/plugins';
import util from '@/util';
import '@/assets/style/all.less';
import Token from './data/token.json';
import * as jsApiHelper from 'jsapi-helper';
import $ from 'jquery';

window.Vue = Vue;
const urlParams = util.getUrlParams();
const identifier = urlParams.identifier;
const isScrm = !!urlParams.isScrm;
// 是否是无身份，会经常判断，写在window下
window.isPublic = !!identifier;
// 
window.FS = {};
window.$ = $;
window.jQuery = $;

const ua = navigator.userAgent.toLowerCase();
const isWxBrowser = ua.match(/MicroMessenger/i) == 'micromessenger';

let env = 'fxiaoke';
if (location.origin.includes('ceshi112') || location.origin.includes('localhost')) {
  env = 'ceshi112';
}
const envMap = {
  ceshi112: 'FSAID_5f5e28a',
  fxiaoke: 'FSAID_5f5e533',
};

// 企微初始化会报corpid的错误，反正也用不到，无身份版本就先不初始化了
if (!isScrm && !isWxBrowser) {
  jsApiHelper.init({
    beta: true,
    debug: true,
    appId: envMap[env],
    timestamp: Date.now(),
    jsApiList: [
      'selectEnterpriseContact', //通讯录选人
      'uploadImage', //上传图片
      'previewImage', //预览图片
      'getLocation', //获取地理位置
      'hideMenuItems', //批量显示功能按钮
      'hideAllNonBaseMenuItem',
      'scanQRCode',
      'chooseImage',
    ],
    // jsApiList: ['selectEnterpriseContact', 'uploadImage', 'previewImage', 'getLocation', 'showMenuItems'],
    onSuccess: function (e) {
      console.log(JSON.stringify(e));
    },
    onFail: function (e) {
      console.log(JSON.stringify(e));
    },
  });
  window.jsApi = jsApiHelper;
}

if (process.env.NODE_ENV === 'development') {
  window.$development = true;
  // 开发模式下注入cookie
  const date = new Date();
  date.setDate(date.getDate() + 30 * 3600);
  date.toGMTString();
  document.cookie = `fs_token=${Token.fs_token};path=/;expires=${date}`;
  document.cookie = `FSAuthX=${Token.FSAuthX};path=/;expires=${date}`;
  document.cookie = `FSAuthXC=${Token.FSAuthX};path=/;expires=${date}`;
  document.cookie = `ERInfo=${Token.ERInfo};path=/;expires=${date}`;
  document.cookie = `CRInfo=${Token.ERInfo};path=/;expires=${date}`;
  document.cookie = `lang=${Token.lang};path=/;expires=${date}`;
}

Vue.config.productionTip = false;

Vue.use(plugins);
Vue.use(util);

//引入fxui组件库
const fxLink = document.createElement('link')
fxLink.href = "//a9.fspage.com/FSR/frontend/html/fxui-dist/theme/index-orange.css"
fxLink.rel = "stylesheet"
document.head.appendChild(fxLink)

const fxScript = document.createElement('script')
fxScript.src = "//a9.fspage.com/FSR/frontend/html/fxui-dist/index-all.js"
fxScript.type = "text/javascript"
fxScript.onload = function () {
  new Vue({
    router,
    render: h => h(App),
  }).$mount('#app');
}
document.body.appendChild(fxScript)
